module.exports = __webpack_public_path__ + "media/images/dividend/img-johnmaynardkeynes-4a4f3ff76d2217326b85d467b90c81bf.png";